﻿import React from 'react';
import RawHtml from '../../../../UI/RawHtml';

import TopCarAnimation from '../Animations/TopCarAnimation';


const TopText = (props) => {

    return (
        <div className="col-1-1 car-insurance-campaign__top__content">
            <h1>{props.heading}</h1>
            <p>{props.text}</p>
            <a href={props.buttonLink} className="button button--xlarge button--white">
                <span><RawHtml>{props.buttonText}</RawHtml></span>
            </a>
            <TopCarAnimation />
        </div>
     )
 }                

export default TopText;